/** 先頭がocidで入力されること */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) {
      return true;
    }
    return /^ocid/.test(value);
  },
};
